module.exports = __webpack_public_path__ + "img/logoEasy2019.03e8a672.png";